import PropTypes from 'prop-types';
import React from 'react';
import { assign, isString } from 'lodash';
import { connect } from 'react-redux';
import WaypointTooltip from 'components/style/WaypointTooltip';
import styles from 'components/app/topbar/navigation/Navigation.module.css';
import { Link } from 'react-router-dom';

class NavItem extends React.Component {
    static propTypes = {
        title: PropTypes.string,
        style: PropTypes.object,
        icon: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
        active: PropTypes.bool,
        hideTooltip: PropTypes.bool,
        isCollapsed: PropTypes.bool,
        children: PropTypes.element,
        to: PropTypes.string,
        dropdown: PropTypes.bool,
    };

    render() {
        const {
            title,
            icon,
            style,
            active,
            hideTooltip,
            isCollapsed,
            children,
            to,
        } = this.props;
        const navItemStyle = assign(
            {},
            {
                overflowX: 'visible',
                backgroundColor: active ? '#00ADE2' : '',
            },
            style
        );
        const imageStyle = {
            height: '18px',
            maxHeight: '18px',
            display: 'inline-block',
            paddingRight: isCollapsed ? '0px' : '7px',
        };
        const linkStyle = { textDecoration: 'none' };
        const content = (
            <div
                className={styles.navItem}
                style={navItemStyle}
                {...this.props}
            >
                {isString(icon) ? (
                    <img style={imageStyle} src={icon} />
                ) : (
                    <div style={imageStyle}>{icon}</div>
                )}
                {isCollapsed && children}
                <span className={styles.itemTitle}>{title}</span>
                {!isCollapsed && children}
            </div>
        );

        if (isCollapsed && !hideTooltip) {
            return (
                <WaypointTooltip message={title} placement="bottom">
                    <Link to={to} style={linkStyle}>
                        {content}
                    </Link>
                </WaypointTooltip>
            );
        }
        if (to) {
            return (
                <Link to={to} style={linkStyle}>
                    {content}
                </Link>
            );
        }
        return content;
    }
}

const mapState = (state) => {
    const {
        browser: { width },
    } = state;
    return {
        isCollapsed: width < 1433,
    };
};

export default connect(mapState)(NavItem);
